/* eslint-disable import/prefer-default-export */
// import makeRequest from 'utils/makeRequest';
// import Cookie from 'utils/cookies';
import { fireActivity } from 'modules/WithTimesPoint/TimesPointUtils';
// import { LOGIN_MAPPED_ON_LIVE } from 'constants/index';
import reducerRegistry from '../../reduxUtils/reducerRegistry';

const reducerName = 'timesPoint';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const LOGIN_POINTS_RECEIVED = createActionName('LOGIN_POINTS_RECEIVED');
export const NON_LOGIN_POINTS_RECEIVED = createActionName(
  'NON_LOGIN_POINTS_RECEIVED',
);
export const POINTS_RECEIVED_ERROR = createActionName('POINTS_RECEIVED_ERROR');
export const INITIALIZE_TP_FLAG = createActionName('INITIALIZE_TP_FLAG');
export const HEADER_CROWN_REWARD_POINTS = createActionName(
  'HEADER_CROWN_REWARD_POINTS',
);

// function fetchLoginTimesPoint(dispatch) {
//   // const url = `https://${
//   //   LOGIN_MAPPED_ON_LIVE || __PROD__
//   //     ? 'tpapi.timespoints.com'
//   //     : 'test.timespoints.com/tpapi'
//   // }/nextEngagement?pfm=msite&pname=TOI&widget=true&uid=${ssoid}`;
//   // return makeRequest.get(url);
// }
export function videoWatchPoints(msid = '', isWapView = false) {
  // const ssoid = Cookie.get('ssoid');
  fireActivity(isWapView, 'watch_video', msid, '', 'News');
  // const url = `https://tpapi.timespoints.com/v1/activity/logact?uid=${ssoid}&pcode=TOI&scode=News&aname=watch_video&pfm=WEB&txnId=${msid}`;
  // return makeRequest.get(url);
}

// function receiveLoginTimesPoints(userPointsData) {
//   return {
//     type: LOGIN_POINTS_RECEIVED,
//     payload: userPointsData,
//   };
// }
export function receiveHeaderRewardPoints(rewardPoints) {
  return {
    type: HEADER_CROWN_REWARD_POINTS,
    payload: rewardPoints,
  };
}
// function handleLoginTimesPointsError() {
//   return {
//     type: POINTS_RECEIVED_ERROR,
//   };
// }

export function setInititializeTPFlag() {
  return {
    type: INITIALIZE_TP_FLAG,
    payload: '',
  };
}

export function loadLoginTimesPoints(data) {
  let userData = {
    response: {},
  };
  try {
    userData = JSON.parse(data);
  } catch (e) {
    // console.log(e);
  }
  return {
    type: LOGIN_POINTS_RECEIVED,
    payload: userData,
  };
}
export default function reducer(state = {}, action) {
  switch (action.type) {
    case LOGIN_POINTS_RECEIVED:
      return {
        ...state,
        points:
          action.payload.response && action.payload.response.points
            ? action.payload.response.points
            : 0,
        userData: action.payload.response,
      };
    case INITIALIZE_TP_FLAG:
      return {
        ...state,
        tpinitialized: true,
      };
    case HEADER_CROWN_REWARD_POINTS:
      return {
        ...state,
        headerCrownPoints: action.payload,
      };
    default:
      return state;
  }
}
reducerRegistry.register(reducerName, reducer);
